export const regexValidation = {
  trim: /^(?! )/,
  vatNumber: /^\d{15}$/,
  numberWithMaxSixDecimals: /^\d+\.?\d{0,6}$|^\.?\d{0,6}$/,
  numberWithMaxTwoDecimals: /^\d+\.?\d{0,2}$|^\.?\d{0,2}$/,
  numberWithMaxThreeDecimals: /^\d+\.?\d{0,3}$|^\.?\d{0,3}$/,
  noSpecialCharacters: /^[a-zA-Z0-9\u0600-\u06FF\s.,\-/()@&]*$/,
};
